module.exports = __webpack_public_path__ + "img/stairs1.002ee340.png";